import styled from 'styled-components';

const StyledContainerWrapper = styled.div`
	position: absolute;
	right: 10px;
	top: 10px;
	width: calc(500px - 130px);
	height: calc(100% - 20px);
`;

const StyledContentContainer = styled.div`
	position: relative;
	width: 100%;
	height: calc(100% - 50px);
	display: flex;
	flex-direction: column;
	gap: 10px;
	overflow-y: auto;

	&::-webkit-scrollbar {
		display: none;
	}
`;

const StyledButtonContainer = styled.div`
	position: relative;
	display: flex;
	width: 100%;
	height: 40px;
	margin-top: 10px;
	border-radius: 8px;
	gap: 10px;
	justify-content: flex-end;

	button {
		border-width: 0;
		border-radius: 8px;
		padding: 5px 10px;
		font-family: 'GT Walsheim Pro';
		font-size: 14px;
		color: #ffffff;
		background-color: #1678c2;
		cursor: pointer;
		transition: background-color 0.25s ease;

		&:hover {
			background-color: #2185d0;
		}

		&:focus {
			outline: 0;
		}
	}
`;

export {
	StyledContainerWrapper as ContentContainerWrapper,
	StyledContentContainer as ContentContainer,
	StyledButtonContainer as ButtonContainer,
};
